import { Component, OnInit } from '@angular/core';
import { JobOfferService } from '../../services/joboffer/job-offer.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-job-offer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './job-offer.component.html',
  styleUrls: ['./job-offer.component.scss']
})
export class JobOfferComponent implements OnInit {
  companyName: string = '';
  jobTitle: string = '';
  applyLink: string = '';
  location: string = '';
  salary: string = '';
  experience: string = '';
  requirements: string[] = [];

  constructor(private jobOfferService: JobOfferService) {}

  ngOnInit(): void {
    const offer: { 
      companyName: string; 
      jobTitle: string; 
      applyLink: string; 
      location: string; 
      salary: string; 
      experience: string; 
      requirements: string[]; 
    } | null | undefined = this.jobOfferService.getJobOfferByTitle('Desarrollador Frontend');
    
    if (offer !== undefined && offer !== null) {
      this.companyName = offer.companyName;
      this.jobTitle = offer.jobTitle;
      this.applyLink = offer.applyLink;
      this.location = offer.location;
      this.salary = offer.salary;
      this.experience = offer.experience;
      this.requirements = offer.requirements;
    }
  }

  getMailtoLink(): string {
    const subject = `Solicitud de empleo para ${this.jobTitle}`;
    const body = `Hola, me interesa postularme para el puesto de ${this.jobTitle}. Adjunto mi CV.`;
    return `mailto:${this.applyLink}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }
}
